/* eslint-disable */
import React, { useState } from "react";
import CardContent from "@material-ui/core/CardContent";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import Avatar from "@material-ui/core/Avatar";
import styles from "./EpisodeList.module.css";
import LinearProgress from "@material-ui/core/LinearProgress";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import { Video } from "../../../stores/program/model/Program";
import PuiTypography from "../../../components/elements/PuiTypography";
import { createStyles, makeStyles } from "@material-ui/core";
import PuiTooltip from "../../../components/elements/PuiTooltip ";
import useResponsive from "../../../common/useResponsive";

interface EpisodeProps {
  /* リストタイトル */
  title: string;
  /* リスト内容　name,remark,image */
  itemList: Video[];
  /* 画像の形 */
  imageShape: "circular" | "rounded" | "square";
  // 選択されたビデオ
  selected: Video | undefined;
  // セレクトエリア用コールバック関数
  onCallback: any;
}

const useStyles = makeStyles(() =>
  createStyles({
    barColorPrimary: {
      backgroundColor: "var(--red)",
    },
  })
);

export default function EpisodeList({ ...props }: EpisodeProps) {
  const classes = useStyles();
  const { isMobile } = useResponsive();
  const [episodeList] = useState<Video[]>(props.itemList);

  // 視聴履歴の進捗インジケータを計算
  const normalise = (video: Video) => {
    if (video.viewingActivities.length === 0) {
      return 0;
    } else {
      const progressMillis = video.viewingActivities[0].progressMillis;
      const isFinished = video.viewingActivities[0].isFinished;
      if (progressMillis !== null) {
        const rate = Math.floor(
          (Number(progressMillis) / Number(video.durationMillis)) * 100
        );
        // console.log(rate)
        return rate;
      } else if (progressMillis === null && isFinished) {
        return 100;
      }
    }
  };

  // ミリ秒を「HH:mm:ss」に変換
  const formatTime = (durationMillis: number) => {
    const hour = Math.floor(durationMillis / 3600000);
    const minute = Math.floor((durationMillis - 3600000 * hour) / 60000);

    const hh = ("00" + hour).slice(-2);
    const mm = ("00" + minute).slice(-2);
    const ms = ("00000" + (durationMillis % 60000)).slice(-5);

    if (hh === "00") {
      const time = `${mm}:${ms.slice(0, 2)}`;
      return time;
    } else {
      const time = `${hh}:${mm}:${ms.slice(0, 2)}`;
      return time;
    }
  };

  // エピソードエリアをクリック時
  const changeFocus = (video: Video) => {
    // console.log("Focus one: ",video)
    // フォーカスされたビデオをセット
    props.onCallback(video);
  };

  return (
    <>
      <div className={styles.listTitle}>
        <PuiTypography size={isMobile ? 16 : 20} bold={true}>
          {props.title}
        </PuiTypography>
      </div>
      <div className={styles.card}>
        {episodeList.map((video) => (
          <CardActionArea
            key={video.id}
            onClick={() => changeFocus(video)}
            style={{ marginBottom: "3px" }}
          >
            <CardContent
              key={video.id}
              className={styles.listItem}
              style={
                props.selected?.id === video.id
                  ? { backgroundColor: "lightgray" }
                  : {}
              }
            >
              <CardMedia className={styles.image}>
                <Avatar
                  src={video.imageUrl}
                  variant="square"
                  style={{ height: "90%", width: "100%" }}
                  className={styles.imageDetail}
                />
                <LinearProgress
                  className={styles.progressBar}
                  classes={{ barColorPrimary: classes.barColorPrimary }}
                  variant="determinate"
                  value={normalise(video)}
                />
                <GridListTileBar
                  title={formatTime(video.durationMillis)}
                  classes={{
                    root: styles.titleBar,
                    title: styles.title,
                    titleWrap: styles.titleWrap,
                  }}
                />
              </CardMedia>
              <div className={styles.listText}>
                <div
                  className={styles.videoName}
                  data-tip={video.title}
                  data-for="videoName"
                >
                  <PuiTypography size={isMobile ? 16 : 20} bold={true} rows={2}>
                    {video.title}
                  </PuiTypography>
                </div>
                <div className={styles.remark}>
                  <PuiTypography
                    size={isMobile ? 14 : 16}
                    color="gray-61"
                  >{`Presenter: ${video.presenter}`}</PuiTypography>
                </div>
              </div>
              <PuiTooltip id={"videoName"} />
            </CardContent>
          </CardActionArea>
        ))}
      </div>
    </>
  );
}
